/**
 * Extract the stored upload basename from plan_url / file paths
 * so /api/files/view/:filename and recursive disk lookup work.
 */
export function fileBasenameFromUrl(urlOrPath) {
  if (urlOrPath == null) return '';
  let s = String(urlOrPath).trim();
  if (!s) return '';
  try {
    s = decodeURIComponent(s);
  } catch {
    /* keep raw */
  }
  s = s.split('?')[0].split('#')[0];
  s = s.replace(/\\/g, '/');
  // Absolute or relative API URLs
  s = s.replace(/^https?:\/\/[^/]+/i, '');
  s = s.replace(/^\/?api\/files\/(?:view\/)?/i, '');
  // Windows absolute path leftover
  if (/^[A-Za-z]:\//.test(s) || s.includes('storage/uploads')) {
    s = s.replace(/^.*\//, '');
  } else {
    s = s.replace(/^.*\//, '');
  }
  return s.trim();
}

/** Prefer API view url / filename; never use Windows disk path as plan_url. */
export function planUrlFromUploadResponse(data) {
  if (!data) return null;
  const filename = data.filename || data.data?.filename;
  if (filename) {
    const base = fileBasenameFromUrl(filename);
    if (base) return `/api/files/view/${base}`;
  }
  const url = data.url || data.data?.url;
  if (url && typeof url === 'string') {
    if (/^[A-Za-z]:\\/.test(url) || url.includes('storage/uploads') || /^[A-Za-z]:\//.test(url)) {
      const base = fileBasenameFromUrl(url);
      return base ? `/api/files/view/${base}` : null;
    }
    const base = fileBasenameFromUrl(url);
    return base ? `/api/files/view/${base}` : url;
  }
  return null;
}
